export default "__VITE_ASSET__CGWOQVaf__"